var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-alert',{attrs:{"id":"alert","value":_vm.isErrorDisplayed,"type":"error","dismissible":""},on:{"input":_vm.setErrorDisplayed}},[_vm._v(" "+_vm._s(_vm.getErrorMessage)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }